import axios, { AxiosError } from 'axios';

axios.defaults.baseURL = process.env.REACT_APP_NEWS_FACTORY_API_URL;

axios.interceptors.response.use(
    response => response,
    (error: AxiosError) => {
        const requestUrl = error.config?.url ?? '';
        const ignored401Routes = ['/api/me', '/api/login_check', '/token', '/api/logout'];
        const isIgnored401Route = ignored401Routes.some(route => requestUrl.includes(route));
        const isOnLoginPage = window.location.pathname === '/login';

        if (error.response?.status === 401 && !isIgnored401Route && !isOnLoginPage) {
            localStorage.clear();
            window.location.href = '/login';
        }

        return Promise.reject(error);
    },
);
axios.interceptors.request.use(
    config => {
        if (config.url === '/token') {
            return config;
        }

        const token = localStorage.getItem('bearer');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    error => Promise.reject(error),
);
